import { connect } from "umi";
import { RegionCountrySelector } from "@/pages/datalab/components/FilterPicker/RegionCountrySelector";
import React from "react";
import { EntryProps } from "../interface";
import { namespace } from '../../model';

// import { HokRegionCountry } from "../widgets/hokRegionCountry";

export const FilterCountyEntry = connect((state, props) => ({
  regionCountries: props?.regionCountries || state[namespace].regionCountries,
  popularList: props?.popularList || state[namespace].popularList
}))((props: EntryProps) => {
  const { column, onChange, isEn, regionCountries, popularList } = props;

  return (
    <>
      <span className="fs-entry-text-prefix">{isEn ? "is" : "是"}</span>
      <RegionCountrySelector
        regionCountry={regionCountries}
        popularList={popularList}
        value={column.column_value || []}
        onChange={(act, country, text) => onChange(act, country, text)}
        isEn={isEn}
      />
    </>
  );
});
